// auto-generated by Typewriter template _models.tst from PortCall.EndPoints\Api\ScheduleDateEvent\ApiScheduleDateEvent.cs
import S, { DataSignal } from 's-js';
import SArray, { SDataArray } from 's-array';
import TZDate from 'lib/TZDate';
import { jsonableObservable } from 'lib/jsonableObservable';
import { Issue, IssueData, IssueOptions } from 'data/models/Issue';
import { PortCallChange, PortCallChangeData, PortCallChangeOptions } from 'data/models/PortCallChange';
import { ScheduleDateEntity, ScheduleDateEntityData, ScheduleDateEntityOptions } from 'data/models/ScheduleDateEntity';

// ScheduleDateEventData is the class that ScheduleDateEvent serializes to/from
export interface ScheduleDateEventData {
    Id : number;
	
    ScheduleChange : PortCallChangeData | null;
    ScheduleChangeId : number;
    ScheduleDate : ScheduleDateEntityData | null;
    ScheduleDateId : number;
    ScheduleDateIssues : IssueData[] | null;
	
    Date : /* ISO8601 */ string | null;
    Type : string | null;
}

// ScheduleDateEventOptions is the class which may be passed to the ScheduleDateEvent constructor to define optional initial data values
export interface ScheduleDateEventOptions {
    Id : number;
	
    ScheduleChange? : PortCallChangeOptions | null;
    ScheduleChangeId? : number;
    ScheduleDate? : ScheduleDateEntityOptions | null;
    ScheduleDateId? : number;
    ScheduleDateIssues? : IssueOptions[] | null;
	
    Date? : /* ISO8601 */ string | null;
    Type? : string | null;
}

export class ScheduleDateEvent {
    public Id : DataSignal<number>;
	
    public ScheduleChange : DataSignal<PortCallChange | null>;
    public ScheduleChangeId : DataSignal<number>;
    public ScheduleDate : DataSignal<ScheduleDateEntity | null>;
    public ScheduleDateId : DataSignal<number>;
    public ScheduleDateIssues : SDataArray<Issue>;
	
    public Date : DataSignal<TZDate | null>;
    public Type : DataSignal<string | null>;

    constructor();
    constructor(data : ScheduleDateEventOptions);
    constructor(data: ScheduleDateEventOptions | null = null) {
        this.Id = jsonableObservable(S.value<number>(data && data.Id !== undefined ? data.Id : 0));
	    
        this.ScheduleChange = S.value<PortCallChange | null>(null);
        this.ScheduleChangeId = jsonableObservable(S.value<number>(data && data.ScheduleChangeId !== undefined ? data.ScheduleChangeId : 0));
        this.ScheduleDate = S.value<ScheduleDateEntity | null>(null);
        this.ScheduleDateId = jsonableObservable(S.value<number>(data && data.ScheduleDateId !== undefined ? data.ScheduleDateId : 0));
        this.ScheduleDateIssues = SArray<Issue>([]);
	    
        this.Date = jsonableObservable(S.value<TZDate | null>(data && data.Date !== undefined ? data.Date === null ? null : new TZDate(data.Date) : null, TZDate.nullableEq));
        this.Type = jsonableObservable(S.value<string | null>(data && data.Type !== undefined ? data.Type : null));
    }

    static key(obj : ScheduleDateEvent) {
        return obj.Id();
    }
    
    static dataKey(obj : ScheduleDateEventOptions) {
        return obj.Id;
    }

    static update(obj : ScheduleDateEvent, data : ScheduleDateEventOptions) {
        S.freeze(() => {
            if (data.Id !== undefined) obj.Id(data.Id);
	        
            if (data.ScheduleChangeId !== undefined) obj.ScheduleChangeId(data.ScheduleChangeId);
            if (data.ScheduleDateId !== undefined) obj.ScheduleDateId(data.ScheduleDateId);
	        
            if (data.Date !== undefined) obj.Date(data.Date === null ? null : new TZDate(data.Date));
            if (data.Type !== undefined) obj.Type(data.Type);
        });
    }
}



// WEBPACK FOOTER //
// ./server/models/ScheduleDateEvent.ts